import React from 'react';
import '../../App.css';
import '../joinWrapp2/joinWrapp2.css';
import { Link } from 'react-router-dom';

function JoinWrapp2({data}) {
  return (
    <section className="join-wrapp2">
        <div className="container">
            <div className="row">
                <div className="col-12">
                <p dangerouslySetInnerHTML={{ __html: data?.readycontent }} />
                    <div className="button-cover">
                    <Link to="/registerPage">
                    <button className="reg-btn">Register Free</button>
                    </Link>
                    <Link to="/loginPage">
                    <button className="log-btn">Login to your Portal</button>
                    </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default JoinWrapp2
